import { humanizeTier, Tooltip } from '@leland-dev/leland-ui-library';
import React from 'react';

import {
  type GoalName,
  type SkuTier,
} from '../__generated-gql-types__/globalTypes';
import { getTierDescription } from '../utils/tier';

interface Props {
  tier: SkuTier;
  goal: Possible<GoalName>;
  hideTooltip?: boolean;
  tooltipSide?: 'top' | 'bottom' | 'left' | 'right';
}

const TierContent: React.FC<{ tier: SkuTier }> = ({ tier }) => (
  <div className="size-fit rounded bg-leland-gray-hover px-1 py-0.5 text-sm font-medium text-leland-gray-extra-light">
    <p className="sm:whitespace-nowrap">{humanizeTier(tier).toUpperCase()}</p>
  </div>
);

export const TierBadge: React.FC<Props> = ({
  tier,
  goal,
  hideTooltip,
  tooltipSide = 'top',
}) => {
  return hideTooltip ? (
    <TierContent tier={tier} />
  ) : (
    <Tooltip
      side={tooltipSide}
      content={getTierDescription(tier, goal)}
      className="w-fit"
    >
      <TierContent tier={tier} />
    </Tooltip>
  );
};
